/**
 * Database name validation utility functions
 * Database names cannot contain spaces
 */

/**
 * Validates a database name - checks if name is provided and does not contain spaces
 * @param {string} dbName - The database name to validate
 * @returns {Object} - Object containing isValid boolean and error message if invalid
 */
export const validateDatabaseName = (dbName) => {
  if (!dbName || !dbName.trim()) {
    return {
      isValid: false,
      error: "Database name is required"
    };
  }

  // Check for spaces in the database name
  if (dbName.includes(" ")) {
    return {
      isValid: false,
      error: "Database name cannot contain spaces"
    };
  }

  return {
    isValid: true,
    error: null
  };
};

/**
 * Real-time validation for database name input
 * @param {string} value - The current input value
 * @returns {string} - Error message or empty string if valid
 */
export const getDatabaseNameValidationError = (value) => {
  if (!value || !value.trim()) {
    return ""; // No error for empty input during typing
  }

  // Check for spaces in the database name
  if (value.includes(" ")) {
    return "Database name cannot contain spaces";
  }

  const validation = validateDatabaseName(value);
  return validation.error || "";
}; 